

import Vue from 'vue';
import Vuex from 'vuex';

import mapModule from './module/mapmodule/map';
import searchStore from './module/searchmodule/search';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        factory: {},
    },
    mutations: {
        setFactory(state, factory) {
            state.factory = factory;
        },
    },
    actions: {
        setFactory: ({ commit }, factory) => commit('setFactory', factory),
    },
    modules: {
        mapModule,
        searchStore,
    },
});


